// ProtectedRoute.js
import { Navigate, useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";
import Layout from "../layouts/Layout";
import { useToast } from "../helpers/contexts/ToastContext";
import { useRolePermission } from "../hooks/useRolePermission";

function getAuthToken() {
  const match = document.cookie.match(/(^| )login_token=([^;]+)/);
  return match ? match[2] : null;
}

const ProtectedRoute = ({ children, module, action = "view" }) => {
  const token = getAuthToken();
  const location = useLocation();
  const { showToast } = useToast();
  const { hasPermission } = useRolePermission();
  const hasMessagedRef = useRef(false);

  useEffect(() => {
    const handleForceLogout = () => {
      showToast("Your session has expired, Please login again.", "danger");
    };

    window.addEventListener("force-logout", handleForceLogout);

    return () => {
      window.removeEventListener("force-logout", handleForceLogout);
    };
  }, [showToast]);

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Check module-level permission
  if (module && !hasPermission(module, action)) {
    if (!hasMessagedRef.current) {
        showToast(`Access Denied: You do not have permission to ${action} in the ${module} module.`, "danger");
        hasMessagedRef.current = true;
    }
    return <Navigate to="/" replace />;
  }

  return <Layout>{children}</Layout>;
};

export default ProtectedRoute;
